import { render, staticRenderFns } from "./question-mapping.vue?vue&type=template&id=3cc89a27&scoped=true"
import script from "./question-mapping.vue?vue&type=script&lang=js"
export * from "./question-mapping.vue?vue&type=script&lang=js"
import style0 from "./question-mapping.vue?vue&type=style&index=0&id=3cc89a27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc89a27",
  null
  
)

export default component.exports